import type { Logger } from 'amazon-chime-sdk-js';
import { ConsoleLogger, LogLevel } from 'amazon-chime-sdk-js';
import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

const consoleLogger: Logger = new ConsoleLogger(
  'ChimeSDKReactComponent',
  LogLevel.OFF,
);
export const LoggerContext = createContext<Logger>(consoleLogger);

interface Props {
  logger: Logger;
}

export const LoggerProvider: FC<PropsWithChildren<Props>> = ({
  logger,
  children,
}) => {
  return (
    <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>
  );
};

export const useLogger = (): Logger => {
  const logger = useContext(LoggerContext);
  return logger;
};
